export function toCamel(o) {
    let newO, origKey, newKey, value;
    if (o instanceof Array) {
        return o.map(function (value) {
            if (typeof value === "object") {
                value = toCamel(value);
            }
            return value;
        });
    } else {
        newO = {};
        for (origKey in o) {
            if (o.hasOwnProperty(origKey)) {
                newKey = (
                    origKey.charAt(0).toLowerCase() + origKey.slice(1) ||
                    origKey
                ).toString();
                value = o[origKey];
                if (
                    value instanceof Array ||
                    (value !== null && value.constructor === Object)
                ) {
                    value = toCamel(value);
                }
                newO[newKey] = value;
            }
        }
    }
    return newO;
}

export function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

export const uuid6 = () =>
    "xxx-yxx".replace(/[xy]/g, function (c) {
        let r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });

export function getLastIndexOfIndexedProps(prefix: string, keys: string[]) {
    const keyNumbers = keys
        .filter(x => x.startsWith(prefix))
        .map(x => parseInt(x.replace(prefix, "")))
        .sort();
    const length = keyNumbers.length;

    return length > 0 ? keyNumbers[length - 1] : 0;
}

export const buildNewIndexedProp = (prefix: string, props: string[]) =>
    `${prefix}${getLastIndexOfIndexedProps(prefix, props) + 1}`;

export const maxInt32Value = 0x7fffffff;

export const intToHex = (d: number | string, padding: number) => {
    var hex = Number(d).toString(16);
    padding =
        typeof padding === "undefined" || padding === null
            ? (padding = 2)
            : padding;

    while (hex.length < padding) {
        hex = "0" + hex;
    }

    return hex;
}